import styled from 'styled-components';
export const BackgroundContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow: hidden;
  flex: 1;
  background-color: #fafafb;
  height: 100vh;
  padding: 40px 0px 0px 20px;
  overflow-x: hidden;
  max-width: 1440px;
  @media screen and (min-width: 1440px) {
    align-self: center;
    margin: auto;
  }
  @media (max-width: 768px) {
    padding-left: 0px;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
  padding-right: 30px;
  padding-bottom: 93px;
`;
